import type { Fallacy } from "./types";
import { createStory } from "./types";

export const relativeVsAbsoluteRisk: Fallacy = {
    id: "relative-vs-absolute-risk",
    name: "Relative vs Absolute Risk",
    emoji: "⚠️",
    category: "Manipulasi Statistik",
    description: "Menyajikan perubahan risiko secara **relatif agar terdengar dramatis**, padahal **perubahan absolutnya kecil**.",
    tldr: "\"Risiko naik 50%!\" — dari 0.002% ke 0.003%. Santai.",
    detail: "Relative vs Absolute Risk adalah trik di mana perubahan risiko dinyatakan secara **relatif** (persentase perubahan) alih-alih **absolut** (selisih angka sebenarnya) untuk menciptakan kesan dramatis — atau sebaliknya, mengecilkan risiko.\n\nContoh: \"Risiko penyakit Y naik 50%!\" — padahal angka absolutnya naik dari 0.002% ke 0.003%, peningkatan cuma 0.001%. Sebaliknya, \"Obat ini hanya mengurangi risiko 0.5%\" terdengar kecil, tapi dalam populasi 100 juta orang berarti 500.000 nyawa terselamatkan.\n\nCara mengenali: Selalu minta angka absolut. Tanyakan: \"Berapa angka sebelum dan sesudahnya? Dari populasi berapa?\" **Risiko relatif tanpa konteks absolut** adalah alat propaganda paling ampuh di era informasi.",
    story: createStory("Relative vs Absolute Risk", "⚠️", {
      hook: {
        title: "\"Risiko naik 300%!\"",
        body: "Kedengeran serem... sampai kamu tau angka aslinya naik dari 0.001% ke 0.003%.",
      },
      convo: {
        claim: "Suplemen ini terbukti klinis **mengurangi risiko sakit jantung 50%**! Aku langsung beli buat sekeluarga.",
        response: "Dari 0.4% jadi 0.2%. Dari 1000 orang, cuma 2 yang terhindar. **998 lainnya gak ngaruh.**",
      },
      reveal: {
        body: "Perubahan risiko disajikan secara **relatif** (persentase perubahan) biar kedengeran dramatis. Padahal **angka absolutnya** bisa kecil banget.",
      },
      insight: {
        title: "Bisa juga kebalikannya",
        body: "\"Cuma kurangin risiko 0.5%\" kedengeran kecil. Tapi di 100 juta orang, itu **500.000 nyawa**. Angka relatif bisa bikin gede jadi kecil juga.",
      },
      engagement: {
        title: "Pernah ketipu angka \"naik/turun sekian persen\"? ⚠️",
        body: "Di iklan suplemen atau berita kesehatan? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["misleading-statistics", "base-rate-fallacy", "framing-effect"],
  };
